import { DatePicker } from '@storeblocks/datepicker';
import { useField } from 'formik';
import { type FC } from 'react';

import { useTexts } from '@/hooks/useTexts';
import { useUserDateFnsLocale, useUserLocale } from '@/i18n/hooks';
import { nameof } from '@/util/nameof';

import { TransferOrderFormValues } from '../../types/TransferOrderFormValues';
import { expectedTransferDate } from '../../utils/expectedTransferDate';

export const ExpectedTransferDateSelector: FC = () => {
  const texts = useTexts();
  const locale = useUserLocale();
  const dateFnsLocale = useUserDateFnsLocale();

  const [field, meta, helpers] = useField<
    TransferOrderFormValues['expectedTransferDate']
  >(nameof<TransferOrderFormValues>('expectedTransferDate'));

  return (
    <DatePicker
      {...field}
      id="expected-transfer-date"
      locale={locale}
      format={expectedTransferDate.dateFormat(dateFnsLocale)}
      min={expectedTransferDate.minimumDate()}
      aria-label={texts.orders.form.transfer.expectedTransferDate.title}
      labelText={texts.orders.form.transfer.expectedTransferDate.title}
      selectMonthAriaLabel={texts.datepicker.selectMonthAriaLabel}
      selectYearAriaLabel={texts.datepicker.selectYearAriaLabel}
      hintText={texts.orders.form.transfer.expectedTransferDate.description}
      alertMessageType={meta.touched && meta.error ? 'error' : undefined}
      alertMessage={meta.error}
      // Override the 'onChange' and 'onBlur' as per
      // the Storeblocks documentation.
      onChange={(_, selectedDate) => {
        helpers.setValue(selectedDate.date);
      }}
      onBlur={() => {
        helpers.setTouched(true);
      }}
      size="fluid"
    />
  );
};
